import { authFetch, BASE_BACKEND_URL } from '../auth'
import React, { useEffect, useMemo, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import ErrorView from '../components/ErrorView'
import LoadingScreen from '../components/LoadingScreen'
import ShowDeliveryView from './ShowDeliveryView'
import { ON_BOARD_SALE } from './constants/constants'

const ShowDeliveryApp = () => {
  const { id } = useParams()
  const location = useLocation()

  const [isFetching, setIsFetching] = useState(true)
  const [error, setError] = useState(null)
  const [details, setDetails] = useState(null)
  const [defaultDetails, setDefaultDetails] = useState(null)

  const status = useMemo(
    () => new URLSearchParams(location.search).get('status'),
    [location.search]
  )

  const type_delivery = useMemo(
    () => new URLSearchParams(location.search).get('type_delivery'),
    [location.search]
  )

  const endpoint = useMemo(() => {
    if (type_delivery === ON_BOARD_SALE.key) {
      return `${BASE_BACKEND_URL}/delivery_receipts_onboard/${id}`
    }

    const base =
      status === 'open' || status === 'to_be_assigned' ? 'delivery_requests' : 'delivery_receipts'

    return `${BASE_BACKEND_URL}/${base}/${id}`
  }, [id, status, type_delivery])

  useEffect(() => {
    let isMounted = true
    setIsFetching(true)
    setError(null)

    authFetch(endpoint, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
    })
      .then((res) => {
        if (res.status === 401) {
          window.location = '/'
          return null
        }
        if (res.status === 404) {
          return { error: true, message: 'No se encontró la entrega' }
        }
        return res.json()
      })
      .then((data) => {
        if (!isMounted || data == null) return
        if (data?.error) {
          setError(data.message || 'Ocurrió un error')
        } else {
          setDetails(data)
          setDefaultDetails(data)
        }
      })
      .catch(() => {
        if (isMounted) setError('Error de red o servidor')
      })
      .finally(() => {
        if (isMounted) setIsFetching(false)
      })

    return () => {
      isMounted = false
    }
  }, [endpoint])

  if (isFetching) {
    return <LoadingScreen text="Cargando..." />
  }

  if (error) {
    return <ErrorView error={error} />
  }

  return <ShowDeliveryView details={details} position={id} defaultDetails={defaultDetails} />
}

export default ShowDeliveryApp
